import { IRouteConfig } from "@/app/routing/types";

export const checkIsSubMenu = ({ childrenAsSubMenu, children }: IRouteConfig) =>
	!!childrenAsSubMenu && !!children?.length;

export const getMenuItemKey = ({ pathKey, path, menuKey }: IRouteConfig) =>
	pathKey || path || (menuKey as string);

export const getSubmenuKeys = (routeScheme: IRouteConfig[]) => {
	const keys: string[] = [];

	routeScheme.forEach((route) => {
		const { childrenAsSubMenu, children } = route;

		if (!children?.length) return;

		if (childrenAsSubMenu) keys.push(getMenuItemKey(route));

		keys.push(...getSubmenuKeys(children));
	});

	return keys;
};
